export default "__VITE_ASSET__n7zDh1ZD__"